import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"border":"10px solid white"} }
const _hoisted_2 = { style: {"font-size":"20px","color":"#63acb5","margin-bottom":"5px"} }
const _hoisted_3 = { style: {"font-size":"20px","color":"#63acb5","margin-bottom":"5px"} }
const _hoisted_4 = { style: {"text-align":"left"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "图片大小需小于500kb。", -1)
const _hoisted_6 = { style: {"text-align":"right"} }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#63acb5"} }, " 选择你的颜文字酱！ ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_film = _resolveComponent("film")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_PostNodeHead = _resolveComponent("PostNodeHead")!
  const _component_PostNode = _resolveComponent("PostNode")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_breadcrumb, { separator: "/" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_breadcrumb_item, {
            to: { path: '/plate/' + _ctx.plateData.id + '/page/1' }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.plateData.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_el_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, " No." + _toDisplayString(_ctx.postId), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_input, {
        id: "reply-input",
        modelValue: _ctx.replyInput.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.replyInput.value) = $event)),
        autosize: { minRows: 2, maxRows: 4 },
        type: "textarea",
        placeholder: "来说点什么吧",
        style: {"padding-bottom":"5px"},
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setInputBuff(Number(_ctx.postId), _ctx.replyInput.value)))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  action: "https://forum-api.kgnmb.com/img/upload",
                  headers: { Authorization: _ctx.authToken },
                  multiple: "",
                  "on-success": (response) => {
                _ctx.getUploadInfo(response);
              }
              ,
                  "on-remove": _ctx.delUploadInfo,
                  limit: 5,
                  ref: "upload"
                }, {
                  tip: _withCtx(() => [
                    _hoisted_5
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      color: "#63acb5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_film, { color: "#ffffff" })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["headers", "on-success", "on-remove"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      color: "#63acb5",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drawInfo.status = true)),
                      style: {"--el-button-text-color":"#ffffff","--el-button-hover-text-color":"#ffffff"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" (`ヮ´ ) ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (
              _ctx.replyForumPost(_ctx.postId, _ctx.replyInput.value, _ctx.replyInput.mediaUrl)
              )),
                      color: "#63acb5",
                      loading: _ctx.postingStatus,
                      style: {"--el-button-text-color":"#ffffff","--el-button-hover-text-color":"#ffffff"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 回复 ")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.res.list, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: index,
          style: {"border":"10px solid white"}
        }, [
          _createVNode(_component_PostNode, {
            postNode: item,
            userId: _ctx.userId
          }, {
            "post-head": _withCtx(() => [
              _createVNode(_component_PostNodeHead, { postNode: item }, {
                "post-head-number": _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.replyAdd('No.' + item.id))
                  }, "No." + _toDisplayString(item.id), 9, _hoisted_7)
                ]),
                _: 2
              }, 1032, ["postNode"])
            ]),
            _: 2
          }, 1032, ["postNode", "userId"])
        ])), [
          [_directive_loading, _ctx.loadingStatus]
        ])
      }), 128))
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_pagination, {
        layout: "prev, pager, next",
        "page-size": _ctx.pageRes.size,
        "page-count": Math.ceil(_ctx.res.count / _ctx.pageRes.size),
        "hide-on-single-page": Math.ceil(_ctx.res.count / _ctx.pageRes.size) == 1,
        "current-page": _ctx.pageRes.page,
        "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageRes.page) = $event))
      }, null, 8, ["page-size", "page-count", "hide-on-single-page", "current-page"])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.drawInfo.status,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.drawInfo.status) = $event)),
      direction: _ctx.drawInfo.direction,
      size: _ctx.drawInfo.size
    }, {
      title: _withCtx(() => [
        _hoisted_8
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"text-align":"center"} }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emoji, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                span: 4,
                onClick: ($event: any) => (_ctx.replyAdd(item)),
                key: index,
                style: {"height":"50px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "text",
                    style: {"color":"#63acb5"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "direction", "size"])
  ], 64))
}